import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from './Navbar';
import MysticalParticles from './MysticalParticles';

export default function MystVeilRules() {
  return (
    <div className="min-h-screen flex flex-col relative">
      {/* Magical Background */}
      <div className="fixed inset-0 -z-10">
        <img 
          src="https://cdn.4fingerstudios.com/Mystveil/Mystveil_map.png" 
          alt="Mystveil Township Map" 
          className="w-full h-full object-cover opacity-30 blur-sm" 
        />
        <div className="absolute inset-0 bg-gradient-to-br from-purple-900/20 via-pink-900/20 to-purple-900/20"></div>
      </div>

      {/* Magical Particles */}
      <MysticalParticles />

      {/* Navigation */}
      <Navbar />

      {/* Main Content */}
      <main className="flex-grow px-4 py-8">
        <div className="max-w-5xl mx-auto">
          <div className="mystical-card">
            <h1 className="mystical-title text-black mb-8">
              Mystveil Rules
            </h1>
            
            {/* Introduction */}
            <div className="mystical-card bg-white bg-opacity-95 mb-8">
              <div className="space-y-4">
                <p className="mystical-text text-black">
                  Upon joining Mystveil you agree to the following rules as written below!
                </p>
                <p className="mystical-text text-black">
                  We look over rule breaks on a case by case basis, but please understand that we take the safety of our members and community very seriously. We may give punishments based on our discretion in order to protect our community. So please read them carefully!
                </p>
                <p className="mystical-text text-black">
                  If you have any questions, please reach out to staff to better assist!
                </p>
              </div>
            </div>
            
            {/* The Basics */}
            <div className="mystical-card mb-8">
              <h2 className="mystical-subtitle text-black text-2xl mb-6 pb-2 border-b-2 border-purple-700 border-opacity-30">
                The Basics
              </h2>
              <div className="space-y-4">
                <p className="mystical-text text-black">
                  <span className="font-bold text-purple-800">You Must Be This Tall To Ride This Ride:</span> You must be 16 years or older in order to join! If you are found to be younger than 16, you will be permanently removed from Mystveil Township! So please do not lie about your age.
                </p>
                <p className="mystical-text text-black">
                  <span className="font-bold text-purple-800">Discord and Toyhou.se is Mandatory For Our Group:</span> A majority of our group approval submissions are done through Toyhou.se and we keep all announcements/updates to our discord server! If you do not have a Toyhou.se, do not be alarmed! Our members have plenty of codes to share for everyone. All you need to do is to join our discord server to ask for it!
                </p>
                <p className="mystical-text text-black">
                  <span className="font-bold text-purple-800">One Account Only:</span> Due to how our mechanics work, having multiple accounts is considered cheating! Cheating our mechanics will get you a permanent ban, no questions asked. Please only use one account to play, if you need to move accounts for whatever reason, please let our staff members know.
                </p>
                <p className="mystical-text text-black">
                  <span className="font-bold text-purple-800">No Robots Allowed:</span> We do not allow AI generated artwork under any circumstances.
                </p>
              </div>
            </div>

            {/* Respect */}
            <div className="mystical-card mb-8">
              <h2 className="mystical-subtitle text-black text-2xl mb-6 pb-2 border-b-2 border-purple-700 border-opacity-30">
                Be Kind and Respectful to Each Other
              </h2>
              <p className="mystical-text text-black">
                This is the NUMBER ONE RULE of our group! Please be mindful of your fellow group members and friends, and treat everyone with respect and kindness. If you have a problem or drama with anyone, leave it at the door. If you have a genuine concern about a group member, do not harass them, and instead contact a staff member as soon as possible.
              </p>
            </div>

            {/* Artwork Rules */}
            <div className="mystical-card mb-8">
              <h2 className="mystical-subtitle text-black text-2xl mb-6 pb-2 border-b-2 border-purple-700 border-opacity-30">
                Artwork Rules
              </h2>
              <div className="space-y-4">
                <div>
                  <p className="mystical-text text-black mb-4">
                    <span className="font-bold text-purple-800">All Artwork Must Be Your Own:</span> It's that simple, do not trace, copy or steal existing artwork! Only use references with credit to the original artist who posted them and make sure it is not directly traced over.
                  </p>
                  <div className="mystical-card bg-purple-700 bg-opacity-10 mb-4">
                    <ul className="space-y-2">
                      <li className="mystical-text text-gray-800">Collaborations are fine as long as you place effort in the work.</li>
                      <li className="mystical-text text-gray-800">Bases should be used as minimally as possible.</li>
                    </ul>
                  </div>
                  <p className="mystical-text text-black">
                    Do your best to ensure that each artwork placed in the group is your own and not anyone else's.
                  </p>
                </div>
                
                <p className="mystical-text text-black">
                  <span className="font-bold text-purple-800">Submit Art To The Group:</span> You cannot count an art piece that was not submitted to the group for Chips! Please remember to post your artwork to the group on Toyhouse or Deviantart.
                </p>
                
                <p className="mystical-text text-black">
                  <span className="font-bold text-purple-800">Don't Put It In The Void:</span> All artwork posted and counted for chips must remain publicly available and not deleted in order to ensure your progress in Mystveil is counted. This <strong>especially</strong> includes application sheets! <strong>Once you delete it, that progress is gone forever.</strong>
                </p>
                
                <p className="mystical-text text-black">
                  <span className="font-bold text-purple-800">Boundaries Must Be Respected:</span> Respect the boundaries of your fellow artists, it's that simple! If you do not know what they are, just ask.
                </p>
              </div>
            </div>

            {/* Code of Conduct */}
            <div className="mystical-card mb-8">
              <h2 className="mystical-subtitle text-black text-2xl mb-6 pb-2 border-b-2 border-purple-700 border-opacity-30">
                Code of Conduct
              </h2>
              <div className="space-y-4">
                <p className="mystical-text text-black">
                  <span className="font-bold text-purple-800">Remain Teen For Teen:</span> We do not allow the posting or discussion of NSFW [18+] sexual or suggestive content within the group. We allow mature and sensitive elements in storytelling as long as it aligns with Deviantart and Toyhou.se's policies for such content, content warnings are being placed and it's done with respect and good intentions. Staff reserve the right to moderate any storytelling that breaks our rules.
                </p>
                
                <p className="mystical-text text-black">
                  <span className="font-bold text-purple-800">Respect And Be Kind To Our Staff:</span> Our staff are made up of personnel who work on Mystveil on a volunteer basis. The ARPG is a side project for the video game itself, which is the main priority of our staff team. Due to how small our staff team will remain, we ask that you <strong>do not block any staff members</strong> and that you treat our staff members with respect.
                </p>
                
                <div>
                  <p className="mystical-text text-black mb-4">
                    <span className="font-bold text-purple-800">Remember This Is A Game:</span> This is no place for hate, negativity or drama of any kind. We want Mystveil to remain a positive space for all who wish to join. This means we have a 0 tolerance policy for any words said or actions done with the intent to hurt others.
                  </p>
                  <p className="mystical-text text-black mb-4">This includes but is not limited to:</p>
                  <div className="mystical-card bg-purple-700 bg-opacity-10 mb-4">
                    <ul className="space-y-2">
                      <li className="mystical-text text-gray-800">Racism</li>
                      <li className="mystical-text text-gray-800">Ableism</li>
                      <li className="mystical-text text-gray-800">Anything against the LGBT+ community</li>
                      <li className="mystical-text text-gray-800">Xenophobia</li>
                      <li className="mystical-text text-gray-800">Sexualization of or support of the sexualization of minors regardless if fictional or not</li>
                      <li className="mystical-text text-gray-800">Harassment</li>
                      <li className="mystical-text text-gray-800">Rumors of every kind</li>
                    </ul>
                  </div>
                  <p className="mystical-text text-black">
                    If any of these actions are presented while you are here, you will be banned or barred from entering Mystveil.
                  </p>
                </div>
              </div>
            </div>

            {/* Trading Rules */}
            <div className="mystical-card mb-8">
              <h2 className="mystical-subtitle text-black text-2xl mb-6 pb-2 border-b-2 border-purple-700 border-opacity-30">
                Trading, Adoptables, Items, etc.
              </h2>
              <div className="space-y-4">
                <p className="mystical-text text-black">
                  <span className="font-bold text-purple-800">All Items Are Digital:</span> <strong>All purchases made in the group goes towards supporting the progress of the video game.</strong> Once you pay for something, <strong>there's no refunds!</strong> All Mystveil Township Items, and Adoptables are <strong>digital items, which means you will receive automatically in some shape or form upon payment.</strong>
                </p>
                
                <p className="mystical-text text-black">
                  <span className="font-bold text-purple-800">Only Trade Items Through The Item Center:</span> This is to protect everyone involved. All dealings related to Mystveil items must be done in the Trading Forum in order to protect your account from a deal gone wrong. If you choose to do a backdoor deal, and that person does not follow through, we can not help you get it back. <strong>Remember that Chips and Approved Veilkin can not be traded!</strong>
                </p>
              </div>
            </div>

            {/* Navigation Buttons */}
            <div className="flex flex-wrap justify-center gap-4">
              <Link to="/guide" className="mystical-button">
                Back to Guides
              </Link>
              <Link to="/" className="mystical-button">
                Return Home
              </Link>
            </div>
          </div>
        </div>
      </main>

      {/* Mystical Footer */}
      <footer className="mystical-nav py-6 mt-auto">
        <div className="container mx-auto px-4 text-center">
          <p className="mystical-text font-bold">
            © 2025 4fingerstudios <br /> 
            © 2024 Reckless Dreams. All Rights Reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}